import { createFileRoute } from '@tanstack/react-router';

import { FeatureFlagListView } from '../../../features/feature-flags/feature-flag-list-view';

export const Route = createFileRoute('/admin/feature-flags/')({
  component: FeatureFlagListView,
});
